import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import {ResizeAF} from '../../utils/ResizeAF';
import Event from '../../utils/Event';
import {LANGTAG, LANGUAGE} from '../../global_vars';

const langClass = 'quote--lang-' + LANGTAG;

const template = `
  <div class="quote ${langClass}" :class="{'quote--opened': showMore}">
      <div class="quote__body" ref="body">
        <div class="quote__body-inner" ref="inner">
            <slot></slot>
        </div>
      </div>
      <div class="quote__btn" @click="showMore = true" :class="{'quote__btn--hidden': !showButton}">${LANGUAGE.COM_XCM_READ_MORE}</div>
      <div class="quote__sign">
        <div class="quote__sign-name">
          <slot name="title"></slot>
        </div>
        <div class="quote__sign-position">
          <slot name="sign"></slot>
        </div>
      </div>
  </div>
`;

@Component({
  template: template
})
export default class Quote extends Vue {
  showMore = false;
  showButton = false;

  @Watch('showMore')
  onShowMore() {
    Event.fire('adjust-slider');
  }

  created(): void {
    ResizeAF.instance().on(() => {
      // @ts-ignore
      const inner = <HTMLElement>(this.$refs[`inner`]);
      const body = <HTMLElement>(this.$refs[`body`]);

      this.showButton = inner.clientHeight > body.clientHeight;
    }, false);


    Event.listen('close-quotes', () => {
      this.showMore = false;
    });
  }
}
